<template>
  <div class="menu-mgmt">
    <div class="main-title">
      <p>{{ $t('lang.User Management') }}</p>
    </div>
    <div style="margin-bottom: 40px;"></div>
    <div class="main-body">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
      >
        <el-form-item :label="$t('lang.Account number')">
          <el-input v-model="form.userName" :placeholder="$t('lang.Please input name')" maxlength="50"
                    clearable @input="form.cardNo = form.cardNo.replace(/[^\d]/g,'')"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Agent/Store')">
          <query-unit-tree :unitArr="multipleSelection" @change="handleChange"/>
        </el-form-item>
        <el-form-item :label="$t('lang.Permission')">
          <el-select class="list-input" v-model="form.authoritySchemeNo"
                     :placeholder="$t('lang.Please select a permission')" clearable>
            <el-option
              v-for="(value, key) in authority"
              :key="value"
              :label="value"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.Card number')">
          <el-input v-model="form.cardNo" clearable maxlength="50"
                    :placeholder="$t('lang.Please enter the binding card number')"
                    @input="form.cardNo = form.cardNo.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="onsearch">{{ $t('lang.Inquire') }}</el-button>
        <el-button type="primary" @click="handleAdd(2)">{{ $t('lang.Assign users') }}</el-button>
        <el-button type="primary" @click="handleAdd(0)">{{ $t('lang.Add') }}</el-button>
      </el-form>
      <el-table
        @selection-change="handleSelectionChange"
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
      >
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="userAccountNo" :label="$t('lang.User Number')" width="200"></el-table-column>
        <el-table-column prop="loginNo" :label="$t('lang.Account number')" width="200"></el-table-column>
        <el-table-column prop="carNo" :label="$t('lang.Card number')" width="200"></el-table-column>
        <el-table-column prop="userName" :label="$t('lang.Name')" width="150"></el-table-column>
        <el-table-column prop="agentShop.agentName" :label="$t('lang.Agent')" width="200"></el-table-column>
        <el-table-column prop="agentShop.shopName" :label="$t('lang.Store')" width="200"></el-table-column>
        <el-table-column prop="authoritySchemeNo" :label="$t('lang.Permission')" width="200">
          <template slot-scope="{row}">
            {{ authority[row.authoritySchemeNo] }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.Setup time')" width="200">
          <template slot-scope="{row}">
            <div>{{ $changeTime.showTime(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="280" fixed="right">
          <template slot-scope="{row}">
            <el-button @click="handleAdd(4,row)" type="primary" size="mini">{{ $t('lang.Move out') }}</el-button>
            <el-button @click="handleAdd(1,row)" type="primary" size="mini">{{ $t('lang.Modify permissions') }}
            </el-button>
            <div class="mt20">
              <el-button @click="handleAdd(3,row)" type="primary" size="mini">{{ $t('lang.Edit') }}</el-button>
              <el-button @click="changePasswordBtn(row)" type="primary" size="mini">
                {{ $t('lang.Change the password') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          :current-page="form.beginIndex + 1"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10,20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="titleObj[type]"
      :visible.sync="dialogTableVisible"
      width="500px"
      :show-close="true"
    >
      <!-- 注册 -->
      <div v-if="+type === 0">
        <el-form ref="addform" :model="registerForm" :rules="rules" class="addForm">
          <el-form-item :label="$t('lang.Agent/Store')" prop="unitNo" label-width="100px">
            <query-unit-tree @change="addHandleChange"/>
          </el-form-item>
          <el-form-item :label="$t('lang.Account')" prop="userName" label-width="100px">
            <el-input
              v-model="registerForm.userName"
              :placeholder="$t('lang.Please_enter_account')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Password')" prop="passWord" label-width="100px">
            <el-input
              :maxlength="16"
              type="password"
              v-model="registerForm.passWord"
              :placeholder="$t('lang.Please enter the password')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Confirm password')" prop="rePassWord" label-width="100px">
            <el-input
              :maxlength="16"
              type="password"
              v-model="registerForm.rePassWord"
              :placeholder="$t('lang.Please enter the password again')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.Please select a permission')" prop='authoritySchemeNo' label-width="180px">
            <el-select class="list-input" v-model="registerForm.authoritySchemeNo"
                       :placeholder="$t('lang.Please select a permission')">
              <el-option
                v-for="(value, key) in authority"
                :key="value"
                :label="value"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dfcc">
            <el-button type="primary" @click="registerBtn('addform')">{{ $t('lang.Register_title') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 权限方案 -->
      <div v-else-if="+type === 1">
        <p class="mb20">{{ $t('lang.Please select a permission') }}</p>
        <el-select class="list-input" v-model="authoritySchemeNo" :placeholder="$t('lang.Please select a permission')">
          <el-option
            v-for="(value, key) in authority"
            :key="value"
            :label="value"
            :value="key"
          ></el-option>
        </el-select>
        <div class="mt20 dfe">
          <el-button @click="editBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- 分配用户 -->
      <div v-else-if="+type === 2">
        <p class="mb20">{{ $t('lang.Please select an assignment object') }}</p>
        <el-cascader
          class="mb20"
          v-model='unitNo'
          :placeholder="$t('lang.Please select an organization')"
          :options="$store.state.queryUnitTreeList"
          :props="{ checkStrictly: true ,label:'name',children:'subUnit',value:'unitNo'}"
          clearable></el-cascader>
        <div>
          <p class="mb20">{{ $t('lang.Please select a permission') }}</p>
          <el-select class="list-input" v-model="scheme.authoritySchemeNo"
                     :placeholder="$t('lang.Please select a permission')">
            <el-option
              v-for="(value, key) in authority"
              :key="value"
              :label="value"
              :value="key"
            ></el-option>
          </el-select>
        </div>

        <!-- <query-unit-tree ref="unitTree" @change="distributeHandleChange"/> -->
        <div class="mt20 dfe">
          <el-button @click="editBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- 编辑 -->
      <div v-else-if="+type === 3">
        <p class="mb20">{{ $t('lang.Change user name') }}</p>
        <el-input v-model="userName" class="mb20"></el-input>
        <div class="dfe">
          <el-button @click="editBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- 移出 -->
      <div v-else-if="+type ===4">
        <p class="mb20">{{ $t('lang.Are you sure to move the user out of the agency or store') }}</p>
        <div class="dfe">
          <el-button @click="editBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
      <!-- 改密码 -->
      <div v-else-if="+type ===5">
        <p class="mb20">{{ $t('lang.Are you sure to move the user out of the agency or store') }}</p>
        <div class="dfe">
          <el-button @click="" type="primary">{{ $t('lang.Confirm') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryUserAccount,
  addOrEditUserAccount,
  queryAllAuthorityScheme,
  distributeUserAccount,
  removeUser,
  editUnitMemberAuthorityScheme,
  editContactInfo,
  editAccountPassword
} from '@/api/openCard'
import queryUnitTree from '@/components/common/queryUnitTree';

export default {
  data() {
    return {
      newPassword: '',
      scheme: {
        authoritySchemeNo: ''
      },
      distributeUserAccountFlag: true,
      registerBtnFlag: true,
      editContactInfoFlag: true,
      row: '',
      authoritySchemeNo: '',
      unitMemberNo: '',
      addUnitNo: [],//新增弹窗unitNo
      userName: '',//编辑修改用户姓名
      distributionSelect: [],
      registerForm: {
        userName: '',
        passWord: '',
        rePassWord: '',
        unitNo: '',
        authoritySchemeNo: ""
      },
      titleObj: {
        0: this.$t('lang.Add account'),
        1: this.$t('lang.Edit permissions'),
        2: this.$t('lang.Assign users'),
        3: this.$t('lang.Edit'),
        4: this.$t('lang.Move out')
      },
      type: '',
      total: 0,
      multipleSelection: [],
      form: {
        cardNo: '',
        unitNo: '',
        userName: '',
        authoritySchemeNo: '',
        beginIndex: 0,
        pageSize: 10

      },
      unitNo: [],
      rules: {
        userName: {required: true, message: this.$t('lang.account cannot be empty'), trigger: 'blur'},
        passWord: {required: true, message: this.$t('lang.The password cannot be empty'), trigger: 'blur'},
        rePassWord: {required: true, message: this.$t('lang.The password cannot be empty'), trigger: 'blur'},
        authoritySchemeNo: {required: true, message: this.$t('lang.Please select a permission'), trigger: 'blur'},
      },
      dialogTableVisible: false,
      recordList: [],
      authority: {},
    };
  },
  mounted() {
    this.queryUserAccount();
    this.queryAllAuthorityScheme();
  },
  methods: {
    // 分配选组织
    // distributeHandleChange(val){
    //   this.distributionSelect = val;
    // },
    // 修改密码按钮
    changePasswordBtn(row) {
      this.$prompt(`${this.$t('lang.Account number')} ${row.loginNo}`, this.$t('lang.Modify Password'), {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.Cancel'),
        inputPattern: /\w+/,
        inputErrorMessage: this.$t('lang.The password can only Numbers or letters')
      }).then(({value}) => {
        console.log(value, 'value---');
        this.editAccountPassword(row, value);
      })
    },
    // 修改密码请求
    async editAccountPassword(row, value) {
      console.log(row, value, 'row/value-----');
      const params = {
        accountNo: row.loginNo,
        password: value,
        appType: 11,
        loginType: 6
      }
      try {
        const res = await editAccountPassword(params);
        console.log(res, '修改密码res----');
        if (res.result) {
          this.$message.success('Success')
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 权限方案下拉
    async queryAllAuthorityScheme() {
      const params = {};
      try {
        const res = await queryAllAuthorityScheme(params);
        console.log(res, '权限方案res');
        this.authority = {
          ...res.mdata.authoritySchemeList,
          "-2": this.$t('lang.No permission'),
          "-99": this.$t('lang.All permissions')
        };
      } catch (e) {
        console.log(e);
      }
    },
    // 新增账户弹窗，选择组织
    addHandleChange(val) {
      this.addUnitNo = val;
    },
    // select组件
    handleChange(val) {
      this.unitNo = val
    },
    //确认修改
    async editBtn() {
      if (this.type === 1) {
        // 权限方案
        if (this.authoritySchemeNo === '') {
          this.$message.warning(this.$t('lang.Please select a permission'));
          return;
        }
        const params = {
          unitMemberNo: this.unitMemberNo,
          authoritySchemeNo: this.authoritySchemeNo
        };
        try {
          const res = await editUnitMemberAuthorityScheme(params);
          console.log(res, '编辑权限res');
          if (res.result == 1) {
            this.$message.success(this.$t('lang.Successful'));
          }
        } catch (e) {
          console.log(e);
        }
      } else if (this.type === 2) {
        // 分配用户
        if (!this.unitNo || this.unitNo.length == 0) {
          this.$message.warning(this.$t('lang.Please select an assignment object'));
          return;
        }
        if (!this.scheme.authoritySchemeNo) {
          this.$message.warning(this.$t('lang.Please select a permission'));
          return;
        }
        const params = {
          authoritySchemeNo: this.scheme.authoritySchemeNo,
          unitNo: this.unitNo[this.unitNo.length - 1],
          userAccountNoList: JSON.stringify(this.multipleSelection)
        };
        if (!this.distributeUserAccountFlag) {
          return;
        }
        this.distributeUserAccountFlag = false;
        try {
          const res = await distributeUserAccount(params);
          if (res.result == 1) {
            this.$message.success(this.$t('lang.Successful'));
            this.unitNo = [];
            this.queryUserAccount();
          }
          console.log(res, '分配返回');
        } catch (e) {
          console.log(e);
        }
        setTimeout(() => {
          this.distributeUserAccountFlag = true;
        }, 1000);
      } else if (this.type === 3) {
        // 编辑
        if (this.userName === '') {
          this.$message.warning(this.$t('lang.Please enter user name'));
          return;
        }
        const params = {
          accountNo: this.row.loginNo,
          name: this.userName,
          appType: 11,
          loginType: 6,
        };
        if (!this.editContactInfoFlag) {
          return;
        }
        this.editContactInfoFlag = false;
        try {
          const res = await editContactInfo(params);
          console.log(res, '编辑返回');
          if (res.result == 1) {
            this.$message.success(this.$t('lang.Successful'));
          }
        } catch (e) {
          console.log(e);
        }
        setTimeout(() => {
          this.editContactInfoFlag = true;
        }, 1000);
      } else if (this.type === 4) {
        // 移出
        const params = {
          unitMemberNo: this.unitMemberNo
        };
        const res = await removeUser(params);
        console.log(res, '移出返回');
        if (res.result == 1) {
          this.$message.success(this.$t('lang.Successful'));
        }
      }
      this.dialogTableVisible = false;
      this.queryUserAccount();
    },
    //pageSize
    handleSizeChange(pagesize) {
      this.form.pageSize = pagesize;
      this.queryUserAccount();
    },
    // current
    handleCurrentChange(page) {
      this.form.beginIndex = page - 1;
      this.queryUserAccount();
    },
    // table，input选择
    handleSelectionChange(val) {
      if (val.length === 0) {
        this.multipleSelection = val;
      } else {
        this.multipleSelection = [];
        val.forEach(el => {
          this.multipleSelection.push(el.userAccountNo);
        });
      }
    },
    onsearch() {
      this.form.beginIndex = 0;
      this.queryUserAccount()
    },
    /**获取菜单列表 */
    async queryUserAccount() {
      const params = {
        ...this.form
      };
      if (this.unitNo && this.unitNo.length > 0) {
        params.unitNo = this.unitNo[this.unitNo.length - 1];
      } else {
        params.unitNo = null;
      }
      try {
        const res = await queryUserAccount(params);
        this.recordList = res.ldata;
        this.total = res.mdata.total;
        console.log(res, '用户列表res');
      } catch (e) {
        console.log(e);
      }
    },
    // 所有弹窗弹出
    handleAdd(type, row) {
      this.row = row;
      // 新增账户
      if (type === 0) {
        this.registerForm = {
          userName: '',
          passWord: '',
          rePassWord: '',
          unitNo: ''
        }
      } else if (type === 1) {
        // 修改权限
        this.unitMemberNo = row.unitMemberNo;
        this.authoritySchemeNo = '';
      } else if (type === 2) {
        this.unitNo = [];
        // 分配用户
        if (this.multipleSelection && this.multipleSelection.length === 0) {
          this.$message.warning(this.$t('lang.Please select equipment'));
          return;
        }
        this.distributionSelect = [];
      } else if (type === 3) {
        // 编辑
        this.userName = '';
      } else if (type === 4) {
        // 移出
        this.unitMemberNo = row.unitMemberNo;
      }
      // 修改密码
      // if(type === 5){

      // }
      this.type = type;
      this.dialogTableVisible = true;
    },
    // 注册按钮
    registerBtn(formName) {

      const self = this;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.registerForm.passWord.length < 6) {
            this.$message.error(this.$t('lang.Password at least 6 characters'));
            return;
          }
          if (this.registerForm.passWord !== this.registerForm.rePassWord) {
            this.$message.error(this.$t('lang.The two passwords do not match'));
            return;
          }
          if (!this.addUnitNo || this.addUnitNo.length == 0) {
            this.$message.error(this.$t('lang.Please select agent'));
            return;
          }
          try {
            const params = {
              ...this.registerForm
            }
            params.rePassWord = this.$md5(params.rePassWord);
            params.passWord = this.$md5(params.passWord);
            if (this.addUnitNo && this.addUnitNo.length > 0) {
              params.unitNo = this.addUnitNo[this.addUnitNo.length - 1];
            } else {
              params.unitNo = null;
            }
            if (!this.registerBtnFlag) {
              return;
            }
            this.registerBtnFlag = false;
            const res = await addOrEditUserAccount(params);
            if (res.result == 1) {
              this.$message.success(this.$t('lang.Successful'));
              this.dialogTableVisible = false;
            }
            console.log(res, 'res');
          } catch (e) {

          }
          setTimeout(() => {
            this.registerBtnFlag = true;
          }, 1000);
        } else {
          return false;
        }
      });
    },
  },
  components: {
    queryUnitTree,
  }
};
</script>

<style lang="scss" scoped>
.addForm {
  padding: 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/userMgmt.vue